import {
  Alert,
  Slide,
  Snackbar as SnackbarMui,
  Typography,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useUIActions } from "../hooks/useActions";
import { tokens } from "../theme";

const Snackbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {
    snackbar: { open, message, severity },
  } = useSelector((state) => state.uiReducer);

  const { setSnackbar } = useUIActions();

  const TransitionUp = (props) => {
    return <Slide {...props} direction="down" />;
  };

  return (
    <SnackbarMui
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      autoHideDuration={2500}
      onClose={(e, reason) => {
        console.log("reason => ", reason);
        if (reason === "clickaway") {
          return;
        }
        setSnackbar(
          {
            message: "",
            severity: "info",
          },
          false
        );
      }}
      TransitionComponent={TransitionUp}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Alert
        onClose={() => setSnackbar({ message: "", severity: "info" }, false)}
        severity={severity}
        //   classes={{ action: classes.iconColor }}
        // sx={{ backgroundColor: "#fff" }}
      >
        <Typography
          variant="caption"
          color={colors.black[500]}
          fontWeight={500}
        >
          {message}
        </Typography>
      </Alert>
    </SnackbarMui>
  );
};

export default Snackbar;
